import { createSlice } from "@reduxjs/toolkit";
import { fetchAuditTrailList, getAuditTrailByBedId } from "../actions/auditTrailsAction";

export const auditTrails = createSlice({
  name: "auditTrails",
  initialState: {
    auditTrails: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded: false,
    isManageWardPage: false,
  },
  reducers: {
    userReset: (state) => {
      // state.auditTrails= null;
      state.error = null;
    },

    resetPopup: (state) => {
      state.isLoader = false;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.error = null;
    },
    setManageWardPage: (state) => {
      state.isManageWardPage = true;
    },
    resetManageWardPage: (state) => {
      state.isManageWardPage = false;
    },
  },
  extraReducers: {
    [fetchAuditTrailList.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [fetchAuditTrailList.fulfilled]: (state, { payload }) => {
      state.error = null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false,
      };
    },
    [fetchAuditTrailList.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },

    [getAuditTrailByBedId.pending]: (state, payload) => {
      state.error = null;
      state.isRecordLoaded = false;
      state.isLoader = true;
    },
    [getAuditTrailByBedId.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isRecordLoaded = true;
      state.isLoader = false;
    },
    [getAuditTrailByBedId.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isRecordLoaded = false;
      state.isLoader = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  userReset,
  userSort,
  userSearch,
  resetPopup,
  setManageWardPage,
  resetManageWardPage,
} = auditTrails.actions;

// const myData = [].concat(this.state.data)
//     .sort((a, b) => a.itemM > b.itemM ? 1 : -1)
//     .map((item, i) =>
//         <div key={i}> {item.matchID} {item.timeM}{item.description}</div>
//     );

export default auditTrails.reducer;
